/* eslint-disable no-prototype-builtins */
import Vue from 'vue'
import Vuex from 'vuex'

//const axios = require('axios')
const firebase = require('./firebaseConfig.js')

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        user: null,
        currentUser: null,
        gear: [],
        songs: [],
        mySongs: [],
        feedback: []
    },
    actions: {
        clearData ({ commit }) {
            commit('setGear', [])
        },
        
        fetchGear ({ commit }) {
            firebase.gearCollection.orderBy('createdOn', 'desc').onSnapshot(querySnapshot => {
                const gears = []
                querySnapshot.forEach(doc => {
                    let gear = doc.data()
                    gear.id = doc.id
                    gears.push(gear)
                })
                commit('setGear', gears)
            })
        },

        // eslint-disable-next-line no-unused-vars
        fetchSongs ({ state, commit }) {
            firebase.songCollection.onSnapshot(querySnapshot => {
                const songs = []
                querySnapshot.forEach(doc => {
                    let song = doc.data()
                    song.id = doc.id
                    songs.push(song)
                })
                commit('setSongs', songs)
            })
        },

        fetchMySongs ({ state, commit }) {
            firebase.songCollection.where("author","==",state.currentUser.uid ).onSnapshot(querySnapshot => {
                const songs = []
                querySnapshot.forEach(doc => {
                    let song = doc.data()
                    song.id = doc.id
                    songs.push(song)
                })
                commit('setMySongs', songs)
            })
        },

        createUser({ state }) {
            const newUser = {}
            firebase.userCollection.doc(state.currentUser.uid).set(newUser).then(() => {
                store.dispatch('fetchUser', state.currentUser.uid)
            }).catch(err => {
                console.log(err)
            })
        },

        fetchUser({ commit }, uid) {
            firebase.userCollection.doc(uid).get().then(res => {
                if(res.exists) {
                    const user = res.data()
                    commit('setUser', user)
                } else {
                    store.dispatch('createUser')
                }
            })
        },

        addFeedback ({ state }, val) {
            const feedback = {
                createdOn: new Date(),
                author: state.currentUser.uid,
                message: val.message,
                page: val.page
            }

            firebase.feedbackCollection.add(feedback).then(() => {
                store.dispatch('fetchMyFeedback')
            }).catch(err => {
                console.log(err)
            })
        },

        fetchMyFeedback ({ state, commit }) {
            firebase.feedbackCollection.where("author","==",state.currentUser.uid ).onSnapshot(querySnapshot => {
                const feedback = []
                querySnapshot.forEach(doc => {
                    let fb = doc.data()
                    fb.id = doc.id
                    feedback.push(fb)
                })
                commit('setMyFeedback', feedback)
            })
        },

        addGear ({ state }, val) {
            const gear = val
            gear.createdOn = new Date()
            gear.author = state.currentUser.uid

            firebase.gearCollection.add(gear).then(() => {
                store.dispatch('fetchGear')
            }).catch(err => {
                console.log(err)
            })
        },

        // eslint-disable-next-line no-unused-vars
        deleteGear ({ state }, gearId) {
            firebase.gearCollection.doc(gearId).delete().then(() => {
                store.dispatch('fetchGear')
            }).catch(err => {
                console.log(err)
            })
        },

        // eslint-disable-next-line no-unused-vars
        updateGear({ state }, gear) {
            firebase.gearCollection.doc(gear.id).update(gear).then(() => {
                store.dispatch('fetchGear')
            }).catch(err => {
                console.log(err)
            })
        },

        // eslint-disable-next-line no-unused-vars
        verifyGear({ state }, gearId) {
            firebase.gearCollection.doc(gearId).update({ verified: true }).then(() => {
                store.dispatch('fetchGear')
            }).catch(err => {
                console.log(err)
            })
        },

        // eslint-disable-next-line no-unused-vars
        unverifyGear({ state }, gearId) {
            firebase.gearCollection.doc(gearId).update({ verified: false }).then(() => {
                store.dispatch('fetchGear')
            }).catch(err => {
                console.log(err)
            })
        },

        addGearUser ({ state }, val) {
            const gear = {
                createdOn: new Date(),
                gearId: val
            }

            var gearUser

            // Update bestaande gear list
            if(state.user.gear) {
                gearUser = state.user.gear
                gearUser.push(gear)
            }
            // Nieuwe array toevoegen
            else {
                gearUser = [ gear ]
            }
            
            firebase.userCollection.doc(state.currentUser.uid).update({ gear: gearUser }).then(() => {
                store.dispatch('fetchUser', state.currentUser.uid)
            }).catch(err => {
                console.log(err)
            })
        },

        deleteGearUser ({ state }, gearId) {

            var gearUser = state.user.gear
            var index = gearUser.findIndex(gear => gear.gearId === gearId)
            gearUser.splice(index, 1)

            firebase.userCollection.doc(state.currentUser.uid).update({ gear: gearUser }).then(() => {
                store.dispatch('fetchUser', state.currentUser.uid)
            }).catch(err => {
                console.log(err)
            })
        },

        addSong ({ state }, val) {
            const song = {
                createdOn: new Date(),
                title: val.title,
                artist: val.artist,
                gear: val.gear,
                author: state.currentUser.uid
            }

            firebase.songCollection.add(song).then(() => {
                store.dispatch('fetchMySongs')
            }).catch(err => {
                console.log(err)
            })
        },

        // eslint-disable-next-line no-unused-vars
        updateSongGear({ state }, val) {
            firebase.songCollection.doc(val.id).update({ gear: val.gear }).then(() => {
                store.dispatch('fetchMySongs')
            }).catch(err => {
                console.log(err)
            })
        },

        // eslint-disable-next-line no-unused-vars
        updateSongKnobs({ state }, val) {
            console.log(val)
            firebase.songCollection.doc(val.id).update({ gear: val.gear }).then(() => {
                store.dispatch('fetchMySongs')
            }).catch(err => {
                console.log(err)
            })
        },

        // eslint-disable-next-line no-unused-vars
        deleteSong ({ state }, songId) {
            firebase.songCollection.doc(songId).delete().then(() => {
                store.dispatch('fetchMySongs')
            }).catch(err => {
                console.log(err)
            })
        }
    },
    mutations: {

        setGear (state, val) {
            state.gear = val
        },

        setMySongs (state, val) {
            state.mySongs = val
        },

        setSongs (state, val) {
            state.songs = val
        },

        setMyFeedback (state, val) {
            state.feedback = val
        },

        setUser (state, val) {
            state.user = val
            state.user.name = state.currentUser.displayName
        },

        setCurrentUser (state, val) {
            state.currentUser = val
        },




        addUser (state, val) {
            var hit = true
            for (var i = 0; i < state.users.length; i++) {
                if (state.users[i].uid === val.uid) {
                    hit = false
                }
            }
            if (hit) state.users.push(val)
        },

        setFavorites (state, val) {
            var favoriteRow = state.favorites.find(favorite => favorite.uid === val.uid)
            if (favoriteRow) {
                favoriteRow.favorites = val.favorites
            } else {
                state.favorites.push(val)
            }
        },



        addToPlayers (state, val) {
            state.players[val.uid] = val.props
        },
        addGames (state, val) {
            state.games = val
        },
        setPlays (state, val) {
            state.plays = val
        },
        setCurrentLocation (state, val) {
            state.currentLocation = val
        },
        setTheme (state, val) {
            state.theme = val
        }
    }
})

firebase.auth.onAuthStateChanged(user => {
    store.dispatch('fetchSongs')
    store.dispatch('fetchGear')

    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('fetchMySongs')
        store.dispatch('fetchUser', user.uid)
        store.dispatch('fetchMyFeedback')
    }
})
